/**
 * Validation utilities for form fields
 */

export const isValidZipcode = (zipcode?: string): boolean => /^\d{5}$/.test(zipcode || '');

export const isValidPhone = (phone?: string): boolean => {
    const digitsOnly = (phone || '').replace(/\D/g, '');
    return /^\d{10}$/.test(digitsOnly);
};

export const isValidName = (name?: string): boolean => /^[A-Za-z\-'.\s]+$/.test(name || '');

export const isValidEmail = (email?: string): boolean => {
    if (!email) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

// Validation error messages
export const NAME_VALIDATION_ERROR_MESSAGE = 'Name can only contain letters, hyphens, apostrophes, and spaces';
export const ZIP_VALIDATION_ERROR_MESSAGE = 'Please enter a valid 5-digit ZIP code';
export const PHONE_VALIDATION_ERROR_MESSAGE = 'Please enter a valid 10-digit phone number';
export const EMAIL_VALIDATION_ERROR_MESSAGE = 'Please enter a valid email address';

// Validation functions that return error messages
export const getNameValidationError = (name: string): string =>
    name && !isValidName(name) ? NAME_VALIDATION_ERROR_MESSAGE : '';

export const getZipValidationError = (zipcode: string): string =>
    zipcode && !isValidZipcode(zipcode) ? ZIP_VALIDATION_ERROR_MESSAGE : '';

export const getPhoneValidationError = (phone: string): string =>
    phone && !isValidPhone(phone) ? PHONE_VALIDATION_ERROR_MESSAGE : '';

export const getEmailValidationError = (email: string): string =>
    email && !isValidEmail(email) ? EMAIL_VALIDATION_ERROR_MESSAGE : '';
